import { render } from "./header.calendar.vue?vue&type=template&id=f72dccd6"
import script from "./header.calendar.vue?vue&type=script&lang=js"
export * from "./header.calendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__